export default function initNews($){

  initNewsHeroDetails($);

  if ($('.news-landing').length == 0) {
    return;
  }


    function debounce( fn, threshold ) {
      var timeout;
      threshold = threshold || 150;
      return function debounced() {
        clearTimeout( timeout );
        var args = arguments;
        var _this = this;
        function delayed() {
          fn.apply( _this, args );
        }
        timeout = setTimeout( delayed, threshold );
      };
    }

    var $grid = $('.news-grid__list');
    var newsRequest = null;

    function syncNewsKeywordToUrl(keyword) {
      var params = new URLSearchParams(window.location.search);
      if (keyword) {
        params.set('keyword', keyword);
      } else {
        params.delete('keyword');
      }
      var newUrl = window.location.pathname;
      var queryString = params.toString();
      if (queryString) {
        newUrl += '?' + queryString;
      }
      if (window.location.hash) {
        newUrl += window.location.hash;
      }
      window.history.replaceState({}, '', newUrl);
    }

    function renderNewsResults(html) {
      if ($grid.data('isotope')) {
        $grid.isotope('destroy');
      }
      $grid.html(html);
      $grid.isotope({
        itemSelector: 'article',
        layoutMode: 'fitRows',
        fitRows: {
          gutter: 44
        },
        getSortData: {
          name: '[data-name]',
          date: '[data-publishdate]'
        }
      });
    }

    function fetchNewsResults(keyword) {
      if (typeof netsNews === 'undefined' || !netsNews.ajaxUrl) {
        return;
      }
      if (newsRequest && newsRequest.readyState !== 4) {
        newsRequest.abort();
      }
      syncNewsKeywordToUrl(keyword);
      $grid.addClass('is-loading');
      newsRequest = $.post(netsNews.ajaxUrl, {
        action: 'nets_news_search',
        nonce: netsNews.nonce,
        keyword: keyword
      }).done(function(response) {
        if (response && response.success && response.data && typeof response.data.html === 'string') {
          renderNewsResults(response.data.html);
        }
      }).always(function() {
        $grid.removeClass('is-loading');
      });
    }

    $('.news-filter__form').on('submit', function(e) {
      e.preventDefault();
      var value = $('.news-filter__form input[name="keyword"]').val().trim();
      if (value.length >= 3 || value.length === 0) {
        fetchNewsResults(value);
      }
    });

    $('.news-filter__form input[name="keyword"]').on('keyup', debounce(function() {
      var value = $(this).val().trim();
      if (value.length >= 3) {
        fetchNewsResults(value);
      } else if (value.length === 0) {
        fetchNewsResults('');
      }
    }, 200));

    var initialKeyword = new URLSearchParams(window.location.search).get('keyword') || '';
    initialKeyword = initialKeyword.trim();
    if (initialKeyword.length >= 3) {
      var $keywordInput = $('.news-filter__form input[name="keyword"]');
      if ($keywordInput.length && $keywordInput.val().trim() !== initialKeyword) {
        $keywordInput.val(initialKeyword);
      }
      fetchNewsResults(initialKeyword);
    }

    // init Isotope
    $grid.isotope({
      itemSelector: 'article',
      layoutMode: 'fitRows',
      fitRows: {
        gutter: 44
      },
      getSortData: {
        name: '[data-name]',
        date: '[data-publishdate]'
      }
    });

}

// Toggle the description panel under the featured image on single news posts.
// Mirrors the exhibition slide details pattern (.button_details + .work-details).
function initNewsHeroDetails($) {
  var $hero = $('.news-hero.has-details');
  if (!$hero.length) {
    return;
  }

  $hero.each(function() {
    var $thisHero = $(this);
    var $btn      = $thisHero.find('.button_details').first();
    var $icon     = $btn.find('.nfa');
    if (!$btn.length) {
      return;
    }

    var $details = $thisHero.find('.news-hero__details');

    $btn.off('click.newsHeroDetails').on('click.newsHeroDetails', function(e) {
      e.preventDefault();
      var isOpen = !$thisHero.hasClass('show-details');
      $btn.attr('aria-expanded', isOpen ? 'true' : 'false');
      $icon
        .toggleClass('nfa-plus-circle',  !isOpen)
        .toggleClass('nfa-minus-circle',  isOpen);

      if (isOpen) {
        $thisHero.addClass('show-details');
        $details.stop(true, true).slideDown(250);
      } else {
        $details.stop(true, true).slideUp(250, function() {
          $thisHero.removeClass('show-details');
        });
      }
    });
  });
}

